import * as yup from 'yup';

export default function stringRequired(label) {
  return yup.string().label(label).required();
}
